export default __webpack_public_path__ + "static/uniswap-logo-and-wordmark-8f5378f92203385b0897536ad8141a13.png";